const dict = {
	es: {
		Accounts: 'Cuentas',
		Stores: 'Tienda',
		'Sign In': 'Registrarse',
		'Sign Up': 'Regístrate'
	},
	fr: {
		Accounts: 'Comptes',
		Stores: 'Magasin',
		'Sign In': 'Se connecter',
		'Sign Up': "S'inscrire"
	},
	jp: {
		Accounts: 'wewe',
		Stores: 'dafavas',
		'Sign In': 'dscads',
		'Sign Up': "dssaa"
	}
};

export { dict };
